module.exports = __webpack_public_path__ + "static/media/image_decomposition.be849f29.png";